import { Col, Modal, Row } from 'antd';

import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { useCapturePostHog } from '../../../../hooks/useCapturePostHog';
import type { IncompleteSubmissionsData } from '../../program-dashboard-olh/programDashboardOLHSlice';
import { getTotalIncompleteSubmissions } from '../program-dashboard.helper';
import { closeDashboardModal, DASHBOARD_MODAL } from './modalDashboardSlice';

export const IncompleteSubmissionsModal = ({
  data,
  filtersInfo,
}: {
  data: IncompleteSubmissionsData | null;
  filtersInfo: string;
}) => {
  const dispatch = useAppDispatch();
  const { capturePostHogCustomEvent } = useCapturePostHog();
  const open = useAppSelector((state) => state.modalDashboardSlice.modal === DASHBOARD_MODAL.INCOMPLETE_SUBMISSIONS);

  if (!data) {
    return;
  }
  const missingPharmaSmartData: number = data.submissions_without_pharmasmart_data ?? 0;
  const missingQuestions: number = data.submissions_with_missing_questions ?? 0;
  const total = getTotalIncompleteSubmissions(data);

  return (
    <Modal
      className="dashboardModal"
      width={'40%'}
      title="Incomplete check-ins"
      open={open}
      onCancel={() => {
        capturePostHogCustomEvent('IncompleteSubmissionsModal close modal');
        dispatch(closeDashboardModal());
      }}
      mask={{ blur: false, closable: false }}
      centered
      footer={null}
    >
      <Row className="filtersInfoRow" justify="space-between" align="middle">
        <p style={{ marginTop: 'auto', marginBottom: 'auto' }}>{filtersInfo}</p>
      </Row>
      <Row gutter={10}>
        <Col span={12} style={{ textAlign: 'center' }}>
          <p>Questions incomplete:</p>
          <p className="largeStat">{missingQuestions}</p>
        </Col>
        <Col span={12} style={{ textAlign: 'center' }}>
          <p>PharmaSmart reading incomplete:</p>
          <p className="largeStat">{missingPharmaSmartData}</p>
        </Col>
      </Row>
      <Row gutter={10}>
        <Col span={24} style={{ textAlign: 'center' }}>
          <p>Total incomplete check-ins:</p>
          <p className="largeStat">{total}</p>
        </Col>
      </Row>
    </Modal>
  );
};
